// extracted by mini-css-extract-plugin
export default {"h1":"Grid_h1__axLVH","grid":"Grid_grid__Ji6mD","container":"Grid_container__px7AH","img":"Grid_img__F95Nl","middle":"Grid_middle__pucmT","text":"Grid_text__5A2kx"};